import { app } from '../../../app';

app.component('subscriptionError', {
    bindings: {},
    templateUrl: require('./subscription-error.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/subscription-error/subscription-error.component.js